import { List, ListItemIcon, ListItemText } from "@mui/material";
import React, { Component, Fragment } from "react";
import FullScreenDialog from "./FullScreenDialog";
import env from "../../env";
import Text from "./Text";

class FacebookBot extends Component {
    state = {
        open: false,
    };

    open = () => this.setState({ open: true });
    close = () => this.setState({ open: false });

    render() {
        
        return (
            <Fragment>
                <List className="list">
                    <li className="item" button="true" onClick={this.open} tabIndex={0} aria-label="Converse com nosso assistente virtual no Facebook Messenger">
                        <ListItemIcon tabIndex={-1}><img className="icon" src={env.images.icons.facebook} alt="Logo da Facebook" style={{ width: 70, height: 70 }} /></ListItemIcon>
                        <ListItemText tabIndex={-1}><Text className="text" tabIndex={-1}>Converse com nosso assistente virtual no Facebook Messenger</Text></ListItemText>
                    </li>
                </List>
                <FullScreenDialog aria-label="Detalhes de como adicionar o bot do Geolux no Facebook" title="Facebook" open={this.state.open} onClose={this.close}>
                    <div className="virtual-attendants-modal app background gradient blue" tabIndex={-1}>
                        <div className="facebook">
                            <div className="flex ai-c">
                                <img src={env.images.icons.facebook} alt="Logo da Facebook" className="media-icon" />
                                <Text tabIndex={-1} as="h2" className="text">Facebook</Text>
                            </div>
                            <Text tabIndex={-1} className="align-center">Vá para a página de conversas e clique na barra de pesquisa no canto superior esquerdo</Text>
                            <div className="flex jc-c">
                                <img className="guide-step-image" src={env.images.facebookBot.step_1} alt="Imagem do passo 1 (Facebook)" />
                            </div>
                            <Text tabIndex={-1} className="align-center">Pesquise por "SistemaGeolux" e adicione o bot</Text>
                            <div className="flex jc-c">
                                <img className="guide-step-image" src={env.images.facebookBot.step_2} alt="Imagem do passo 2 (Facebook)" />
                            </div>
                            <Text tabIndex={-1} className="align-center">Digite "Oi" para iniciar a conversa e escolha as opções que mais se encaixam com sua solicitação</Text>
                            <div className="flex jc-c">
                                <img className="guide-step-image" src={env.images.facebookBot.step_3} alt="Imagem do passo 3 (Facebook)" />
                            </div>
                        </div>
                    </div>
                </FullScreenDialog>
            </Fragment>
        );
    }
}

export default FacebookBot;
